<template>
  <div>
    <iframe width="100%" height="700px" :src="pdfUrl" style="display: block"></iframe>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: ['pdfUrl'],
  data() {
    return {
      pageNo: 1, // Initial page number
    };
  },
};
</script>

<style>
/* Add your styling here */
</style>
